import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const images = {
    background: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/background.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/background.jpg`,
        width: 1920,
        height: 1080,
    },
    "clip-tab": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/clip-tab.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/clip-tab.png`,
        width: 160,
        height: 160,
    },
    "flowers-1": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/flowers-1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/flowers-1.webp`,
        width: 1500,
        height: 1500,
    },
    "flowers-2": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/flowers-2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/flowers-2.webp`,
        width: 1500,
        height: 1500,
    },
    "caption/center": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/caption/center.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/caption/center.jpg`,
        width: 888,
        height: 1080,
    },
    "caption/left": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/caption/left.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/caption/left.jpg`,
        width: 475,
        height: 1080,
    },
    "caption/right": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/caption/right.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-garden-rose/optimized/caption/right.jpg`,
        width: 557,
        height: 1080,
    },
};
const greetingTemplate = {
    type: "typeOnGreeting",
    variant: "intro",
    secondsPerCharacter: 0.1,
    minimumMessageDisplayTimeSeconds: 3,
    showLogo: true,
    widthFactor: 0.7,
    sharedMessageAssets: [
        {
            url: images["flowers-2"],
            style: {
                position: "absolute",
                width: "1500px",
                height: "1500px",
                right: 0,
                top: 90,
            },
        },
        {
            url: images["flowers-1"],
            style: {
                position: "absolute",
                width: "1500px",
                height: "1500px",
                left: 0,
                bottom: 90,
            },
        },
    ],
};
export const weddingGardenRose = {
    version: 1,
    themeId: "wedding-garden-rose",
    name: "Wedding Garden Rose",
    endFadeDuration: 1,
    thumbnailFrame: 190,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/wedding-garden-rose.webp`,
    background: [
        {
            variant: "image",
            src: images["background"],
        },
    ],
    scenes: [
        {
            type: "textTransition",
            variant: "intro",
            title: {
                text: "name",
                fontFamily: "Alex Brush",
                fontSize: 240,
                fontWeight: "medium",
                letterSpacing: "normal",
                textColor: "#CC5D4F",
                transition: "drop-character",
            },
            subtitle1: {
                text: "date",
                fontFamily: "Quicksand",
                fontSize: 60,
                fontWeight: "normal",
                letterSpacing: "widest",
                textColor: "#707E72",
            },
            subtitle2: {
                text: "subheading",
                fontFamily: "Quicksand",
                fontSize: 50,
                fontWeight: "normal",
                letterSpacing: "widest",
                textColor: "#707E72",
            },
            rightImage: {
                url: images["flowers-2"],
            },
            leftImage: {
                url: images["flowers-1"],
            },
            durationSeconds: 8,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                colorFilter: "grayscale",
                startAtSeconds: 1,
                entrance: { variant: "zoom-in" },
            },
        },
        {
            ...greetingTemplate,
            variant: "intro",
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            ...greetingTemplate,
            variant: "outro",
        },
        {
            type: "textTransition",
            variant: "outro",
            title: {
                text: "name",
                fontFamily: "Alex Brush",
                fontSize: 240,
                fontWeight: "medium",
                letterSpacing: "normal",
                textColor: "#CC5D4F",
                transition: "drop-character",
            },
            subtitle1: {
                text: "date",
                fontFamily: "Quicksand",
                fontSize: 60,
                fontWeight: "normal",
                letterSpacing: "widest",
                textColor: "#707E72",
            },
            rightImage: {
                url: images["flowers-2"],
            },
            leftImage: {
                url: images["flowers-1"],
            },
            durationSeconds: 5,
            outroVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0.1,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#707E72",
            fontFamily: "Quicksand",
            fontWeight: "normal",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "image-stretch",
                leftUrl: images["caption/left"],
                center: {
                    variant: "stretch-y-repeat-x",
                    url: images["caption/center"],
                },
                rightUrl: images["caption/right"],
                maxWidthPx: 600,
                textContainerStyleOverride: {
                    height: "18rem",
                },
            },
            betweenTransition: {
                variant: "imageSequence",
                timing: { variant: "linear", durationSeconds: 1.5 },
                mask: {
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
                overlay: {
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#555",
                fontFamily: "Pinyon Script",
                fontWeight: "medium",
                fontSize: 80,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#555",
                fontFamily: "EB Garamond",
                fontWeight: "medium",
                fontSize: 48,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 0.7,
            overlay: {
                variant: "corner",
                url: images["clip-tab"].full,
                offsetUnit: "-1rem",
            },
            backgroundVariant: {
                variant: "image",
                images: [
                    [
                        {
                            url: images["flowers-1"],
                            left: 0,
                            width: "1500px",
                            height: "1500px",
                            bottom: 0,
                        },
                        {
                            url: images["flowers-2"],
                            right: 0,
                            width: "1500px",
                            height: "1500px",
                            top: 0,
                        },
                    ],
                    [
                        {
                            url: images["flowers-2"],
                            right: 0,
                            width: "1500px",
                            height: "1500px",
                            top: 0,
                        },
                        {
                            url: images["flowers-1"],
                            left: 0,
                            width: "1500px",
                            height: "1500px",
                            bottom: 0,
                        },
                    ],
                    [
                        {
                            url: images["flowers-1"],
                            left: 0,
                            width: "1500px",
                            height: "1500px",
                            bottom: 500,
                        },
                        {
                            url: images["flowers-2"],
                            right: 0,
                            width: "1500px",
                            height: "1500px",
                            top: 300,
                        },
                    ],
                ],
            },
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "imageSequence",
            timing: {
                variant: "linear",
                durationSeconds: 1.5,
                easing: "linear",
            },
            mask: {
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
            overlay: {
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
        },
    },
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name of Couple",
            defaultValue: "",
            placeholder: "Jessica & David",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "date",
            type: "date",
            label: "Wedding Date",
            defaultValue: "",
            placeholder: "Select a date",
            required: true,
            dateFormat: "MMMM dd, yyyy",
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "subheading",
            type: "text",
            label: "Subheading",
            defaultValue: "Wedding Guest Book",
            min: 0,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
    ],
};
